import React, { useCallback, useState } from 'react';
import { GridApi, GridReadyEvent } from 'ag-grid-community';

import AgGrid from '../../shared/agGrid/agGrid.component';
import { CustomRenderer } from '../../shared/numeralRenderers';
import DateCellRenderer from '../../shared/agGrid/cellRenderers/dateCellRenderer.component';

import GLJournalsPropTypes from './glJournals.propTypes';
import {
  alignCenterCellStyle,
  alignLeftCellStyle,
  alignRightCellStyle,
} from '@common/cellStyles';
import { GlJournal } from './types';

const defaultColumnDefs = {
  ...alignCenterCellStyle,
};

const baseColumnDefs = [
  { headerName: 'Post Date', field: 'POSTED_ON', minWidth: 100, cellRenderer: DateCellRenderer },
  { headerName: 'Company Code', field: 'COMPANY_CODE', minWidth: 80, ...alignLeftCellStyle },
  { headerName: 'Account', field: 'GL_ACCOUNT', minWidth: 100, ...alignLeftCellStyle },
  { headerName: 'Trading Partner', field: 'TRADING_PARTNER', minWidth: 50, ...alignLeftCellStyle },
  { headerName: 'Cost Center', field: 'COST_CENTER', minWidth: 70 },
  { headerName: 'Geography', field: 'GEOGRAPHY', minWidth: 50 },
  { headerName: 'Project', field: 'PROJECT', minWidth: 90 },
  { headerName: 'Reference', field: 'REFERENCE', minWidth: 60 },
  { headerName: 'Book Type', field: 'BOOK_TYPE', minWidth: 50 },
  { headerName: 'Tax Currency', field: 'CURRENCY_CODE', minWidth: 50 },
];

const customColumnDefs = [
  ...baseColumnDefs,
  { headerName: 'Entered Debit', field: 'DEBIT', minWidth: 70, cellRenderer: CustomRenderer, ...alignRightCellStyle },
  { headerName: 'Credit Amount', field: 'CREDIT', minWidth: 70, cellRenderer: CustomRenderer, ...alignRightCellStyle },
  { headerName: 'Account Desc', field: 'ACCT_DESCRIPTION', minWidth: 120, ...alignLeftCellStyle },
];

const TaxEntryDetails = ({ glJournals }: { glJournals: GlJournal[] }) => {
  const [gridApi, setGridApi] = useState<GridApi | null>(null);

  const onGridReady = useCallback<(event: GridReadyEvent) => void>(({ api }) => {
    setGridApi(api);
  }, []);

  const onColumnEverythingChanged = useCallback(() => {
    gridApi?.sizeColumnsToFit();
  }, [gridApi]);

  gridApi?.sizeColumnsToFit();

  return (
    <div className="ag-theme-bootstrap gl-journals-tab">
      <AgGrid
        columnDefs={customColumnDefs}
        defaultColDef={defaultColumnDefs}
        headerHeight={50}
        domLayout="autoHeight"
        rowData={glJournals}
        onGridReady={onGridReady}
        onColumnEverythingChanged={onColumnEverythingChanged}
      />
    </div>
  );
};

TaxEntryDetails.propTypes = {
  glJournals: GLJournalsPropTypes,
};

export default TaxEntryDetails;
